module.exports = __webpack_public_path__ + "static/img/JOBS.8ba09e68.png";